(function ($) {

	//Scroll magic init
	var controller = new ScrollMagic.Controller();

	// CaseExcerpt
	$(".caseExcerpt").each(function (index) {
		var caseExcerpt = new TimelineLite();
		caseExcerpt.fromTo($(this).find(".imageLandscape"), 1, { width: 0 }, { width: 100 + '%', ease: Power2.easeInOut });
		caseExcerpt.fromTo($(this).children(".caseExcerpt__info"), 1, { opacity: 0, yPercent: 15 }, { opacity: 1, yPercent: 0 },'-=0.5');
		caseExcerpt.fromTo($(this).find(".caseExcerpt__number"), 0.5, { opacity: 0, yPercent: 15 }, { opacity: 1, yPercent: 0 },'-=1');
		caseExcerpt.to($(this).children(".caseExcerpt__info"), 0.1, { clearProps: "transform" });
		new ScrollMagic.Scene({
			triggerElement: this
		}).setTween(caseExcerpt)
			//.addIndicators()
			.reverse(false)
			.offset(-600)
			.addTo(controller);
	});

	// scrim animation
	var scrim = new TimelineLite();
	scrim.to($(".scrim").find(".transitionOverlay"), 1, { left: 100 + '%', ease: Power2.easeInOut });
	scrim.fromTo(".scrim__content", 1, { opacity: 0, yPercent: 15 }, { opacity: 1, yPercent: 0 },'-=0.5');
	new ScrollMagic.Scene({
		triggerElement: ".scrim"
	}).setTween(scrim)
		//.addIndicators()
		.reverse(false)
		.offset(-600)
		.addTo(controller);

	// BloggExcerptList animation
	var bloggExcerptList = new TimelineLite();
	bloggExcerptList.to($(".scrimPointer").find(".transitionOverlay"), 1, { left: 100 + '%', ease: Power2.easeInOut });
	bloggExcerptList.fromTo([".scrimPointer__content", ".bloggExcerpt"], 1, { opacity: 0, yPercent: 15 }, { opacity: 1, yPercent: 0 },'-=0.5');
	new ScrollMagic.Scene({
		triggerElement: ".bloggExcerptList"
	}).setTween(bloggExcerptList)
		//.addIndicators()
		.reverse(false)
		.offset(-600)
		.addTo(controller);

	// Clientlogos animation
	var clientLogos = new TimelineLite();
	clientLogos.fromTo($(".clientLogos").find(".container"), 1, { opacity: 0, yPercent: 15, }, { opacity: 1, yPercent: 0 });
	new ScrollMagic.Scene({
		triggerElement: ".clientLogos"
	}).setTween(clientLogos)
		//.addIndicators()
		.reverse(false)
		.offset(-600)
		.addTo(controller);

	// ServicesGrid animation
	var servicesGrid = new TimelineLite();
	servicesGrid.fromTo(".servicesGrid", 1, { opacity: 0, yPercent: 15, }, { opacity: 1, yPercent: 0, delay: 0.5 });


	// caseSingle animation
	var caseSingle = new TimelineLite();
	caseSingle.fromTo($(".case__image").find(".imageLandscape"), 1, { width: 0 }, { width: 100 + '%', ease: Power2.easeInOut });
	caseSingle.fromTo(".case__info", 1, { opacity: 0, yPercent: 15 }, { opacity: 1, yPercent: 0 },'-=0.5');
	caseSingle.to($(".case__info"), 0.1, { clearProps: "transform" });
	new ScrollMagic.Scene({
		triggerElement: ".case"
	}).setTween(caseSingle)
		//.addIndicators()
		.reverse(false)
		.offset(-600)
		.addTo(controller);

	// relatedCase animation
	var relatedCase = new TimelineLite();
	relatedCase.to($(".relatedCase").find(".transitionOverlay"), 1, { left: 100 + '%', ease: Power2.easeInOut });
	relatedCase.fromTo(".relatedCase__info", 1, { opacity: 0, yPercent: 15 }, { opacity: 1, yPercent: 0 },'-=0.5');
	relatedCase.to($(".relatedCase__info"), 0.1, { clearProps: "transform" });
	new ScrollMagic.Scene({
		triggerElement: ".relatedCaseGrid"
	}).setTween(relatedCase)
		//.addIndicators()
		.reverse(false)
		.offset(-600)
		.addTo(controller);

	// blogg animation
	var blogg = new TimelineLite();
	blogg.fromTo(".blogg", 1, { opacity: 0, yPercent: 15 }, { opacity: 1, yPercent: 0, delay: 0.5 });


	// sidebar animation
	var sidebar = new TimelineLite();
	sidebar.fromTo(".sidebar", 1, { opacity: 0, yPercent: 15 }, { opacity: 1, yPercent: 0, delay: 0.5 });

	// service animation
	var service = new TimelineLite();
	service.fromTo(".service", 1, { opacity: 0, yPercent: 15 }, { opacity: 1, yPercent: 0 });


	// Employee
	$(".employee").each(function (index) {
		var employee = new TimelineLite();
		employee.to($(this).find(".transitionOverlay"), 1, { left: 100 + '%', ease: Power2.easeInOut });
		employee.fromTo($(this).find(".employee__info"), 1, { opacity: 0, yPercent: 15 }, { opacity: 1, yPercent: 0 },'-=0.5');
		new ScrollMagic.Scene({
			triggerElement: this
		}).setTween(employee)
			//.addIndicators()
			.reverse(false)
			.offset(-600)
			.addTo(controller);
	});

	// contactUs animation
	var contactUs = new TimelineLite();
	contactUs.to($(".contactUs").find(".transitionOverlay"), 1, { left: 100 + '%', ease: Power2.easeInOut, delay: 0.5 });
	contactUs.fromTo($(".contactUs").find(".formContactUs"), 1, { opacity: 0, yPercent: 15 }, { opacity: 1, yPercent: 0 },'-=0.5');
	new ScrollMagic.Scene({
		triggerElement: ".contactUs"
	}).setTween(contactUs)
		//.addIndicators()
		.reverse(false)
		.offset(-600)
		.addTo(controller);

	// sitemap
	var sitemap = new TimelineLite();
	sitemap.fromTo($(".sitemap"), 1, { opacity: 0, yPercent: 15 }, { opacity: 1, yPercent: 0, delay: 0.5 });

	// NotFound
	var notFound = new TimelineLite();
	notFound.fromTo($(".notFound"), 1, { opacity: 0, yPercent: 15 }, { opacity: 1, yPercent: 0, delay: 0.5 });

	// Navigation animation
	var navigation = new TimelineLite();
	navigation.fromTo(".navigation__logo", 1, { opacity: 0, yPercent: -15 }, { opacity: 1, yPercent: 0 });
	navigation.fromTo(".navigation__menu", 1, { opacity: 0, yPercent: -15 }, { opacity: 1, yPercent: 0 });


	$(document).ready(function () {
		// Initializes the document
		init();

		// HeroHeader animation
		var heroHeader = new TimelineLite();
		heroHeader.to($(".heroHeader").find(".transitionOverlay"), 1, { left: 100 + '%', ease: Power2.easeInOut, delay: 0.5 });
		heroHeader.fromTo(".heroHeader__content", 1, { opacity: 0, yPercent: 15 }, { opacity: 1, yPercent: 0 }, "-=0.5");

		// LoaderCover animation
		var loaderCover = new TimelineLite();
		loaderCover.to(".loaderCover", 1, { left: 100 + '%', ease: Power2.easeInOut });
		loaderCover.to(".loaderCover", 1, { autoAlpha: 0 });

		//Navigation mobile menu
		$('.navigation__hamburger').on('click', function (e) {
			$('.navigation__menu').toggleClass("navigation__menu--active");
			$('body').toggleClass("bodyMove");
		});

		//Tabpanel
		var tabPanel = new TimelineLite();
		tabPanel.fromTo(".tabPanel, .aboutUsContent", 1, { opacity: 0, yPercent: 15 }, { opacity: 1, yPercent: 0, delay: 1 });

		$('.tabPanel__block').on('click', function (e) {
			if (!$(this).hasClass('tabPanel__block--active') && $(this).hasClass('aboutUsContentTrigger')) {
				var aboutUsContent = new TimelineLite();
				aboutUsContent.fromTo($(".aboutUsContent"), 1, { opacity: 0, yPercent: 15 }, { opacity: 1, yPercent: 0 });
				$('.aboutUsContent').css('display', 'block');
				$('.processContent').css('display', 'none');
			} else if (!$(this).hasClass('tabPanel__block--active') && $(this).hasClass('processContentTrigger')) {
				var processContent = new TimelineLite();
				processContent.fromTo($(".processContent"), 1, { opacity: 0, yPercent: 15 }, { opacity: 1, yPercent: 0 });
				$('.aboutUsContent').css('display', 'none');
				$('.processContent').css('display', 'block');
			}
			$(this).addClass('tabPanel__block--active').siblings().removeClass('tabPanel__block--active');
		});


		function init() {
			$('.processContent').css('display', 'none');
		}

		$(window).resize(function () {
			if ($(window).width() >= 767) {
				$(".menuList").css("margin-top", "0px");
				if ($('.navigation__menu').hasClass("navigation__menu--active")) {
					$('body').removeClass("bodyMove");
				}
			} else {
				if ($('.navigation__menu').hasClass("navigation__menu--active")) {
					$('body').addClass("bodyMove");
				}
			}
		});
	});
})(jQuery);





